import React from 'react';
import './Header.css';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await logout();
    }
  };

  return (
    <header className="app-header">
      <div className="logo-section">
        <img 
          src={require('../assets/gls-logo-white.svg').default} 
          alt="GLS Logo" 
          className="gls-logo-img"
        />
      </div>
      <div className="title-section">
        <h1>Parcel Logistics Search System</h1>
        <p>Register search criteria for parcel tracking</p>
      </div>
      <div className="user-section">
        <div className="user-info">
          <span className="user-email">{user?.email}</span>
          <button 
            className="logout-btn" 
            onClick={handleLogout}
            title="Logout"
          >
            <span className="logout-icon">⚬</span>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
